/** A braced crate (lantern-water `world.js` `crate`). Params: `size` (0.7), `y` (0, a crate stacked on another). */
import * as THREE from 'three';
import { num } from '../kit.ts';
import type { Prefab } from './types.ts';

export const prefab: Prefab = {
  id: 'crate',
  buildPrefab(ctx) {
    const root = new THREE.Group();
    ctx.crate(root, 0, 0, num(ctx, 'size', 0.7), num(ctx, 'y', 0));
    return { root };
  },
};
